// ModalMessage.jsx

import React from 'react';

// CSS
import './ModalMessage.css';

/**
 * ModalMessage Component
 * 
 * This component renders a message for a modal item.
 * 
 * @param {string} text - The text of the message.
 * 
 * @returns {ReactNode} The rendered component.
 */
const ModalMessage = ({ text }) => {

  // ----- RENDER ----- //

  return (
    <div className="modal-message-container">
      {text}
    </div>
  );
};

// Dev Tools
ModalMessage.displayName = 'ModalMessage';

export default ModalMessage;
